import { NgRedux } from '@ptl/angular-redux-store';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup } from '@angular/forms';
import { StateStructure } from '@ptl/state';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { toggleHighlights } from './reducers/compare-plans-highlight.reducer';

interface FormControls {
  toggleButton: AbstractControl;
}

interface FormValuesAsJson {
  toggleButton: boolean;
}

@Component({
    selector: 'app-compare-plans-highlight',
    templateUrl: './compare-plans-highlight.component.html',
    styleUrls: ['./compare-plans-highlight.component.scss'],
    standalone: false
})
export class ComparePlansHighlightComponent implements OnInit {

  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private ngRedux: NgRedux<StateStructure>
  ) {
    this.form = this.fb.group({
      toggleButton: this.fb.control(false)
    });
  }

  get formControls(): FormControls {
    return this.form.controls as unknown as FormControls;
  }

  get formValuesAsJson(): FormValuesAsJson {
    return this.form.value as unknown as FormValuesAsJson;
  }

  ngOnInit(): void {
    this.toggleButton();
  }

  toggleButton() {
    this.ngRedux.dispatch(toggleHighlights(this.formValuesAsJson.toggleButton));
  }
}
